const NEW_WINDOW_DATA_EVENT_MAX_RETRIES = 3;

// If partner didn't implement new window data event,
// then we need to skip it and use legacy event instead
class IframeIntegrationFallback {
    private newWindowDataEventRetryCount = 0;

    public countWindowDataEventRetry(): void {
        this.newWindowDataEventRetryCount++;
    }

    public shouldUseWindowDataEventFallback(): boolean {
        return this.newWindowDataEventRetryCount >= NEW_WINDOW_DATA_EVENT_MAX_RETRIES;
    }
}

export const iframeIntegrationFallback = new IframeIntegrationFallback();
